/* ============================================================
   SomosKura — JS del tema (portado de shop.js)
   El carrito YA NO vive en localStorage: usa la Cart AJAX API de Shopify y la
   Section Rendering API, así que el pedido llega de verdad al checkout.
   ============================================================ */
(function () {
  var K = window.KURA || { routes: {}, freeShipping: 119000 };
  var $ = function (id) { return document.getElementById(id); };

  function toast(msg) {
    var t = $('toast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(t._kuraT);
    t._kuraT = setTimeout(function () { t.hidden = true; }, 2600);
  }

  /* ---------- Carrito ---------- */
  function openCart() {
    var d = $('cartDrawer'), b = $('cartBackdrop');
    if (!d) return;
    d.hidden = false;
    if (b) b.hidden = false;
    document.body.classList.add('cart-open');
  }
  function closeCart() {
    var d = $('cartDrawer'), b = $('cartBackdrop');
    if (!d) return;
    d.hidden = true;
    if (b) b.hidden = true;
    document.body.classList.remove('cart-open');
  }

  function updateCartHtml(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#cartDrawer');
    var actual = $('cartDrawer');
    if (fresh && actual) {
      actual.innerHTML = fresh.innerHTML;
      var count = fresh.getAttribute('data-item-count');
      if (count !== null) {
        var n = parseInt(count, 10) || 0;
        var badge = $('cartBadge');
        if (badge) {
          badge.textContent = n;
          badge.hidden = n === 0;
        }
      }
    }
    document.dispatchEvent(new CustomEvent('kura:cart-refreshed'));
  }

  function refreshCart() {
    var cartUrl = (K.routes && K.routes.cart ? K.routes.cart : '/cart') + '?section_id=cart-drawer';
    return fetch(cartUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        updateCartHtml(html);
      })
      .catch(function () { /* silencio: no romper UI si falla la red */ });
  }

  function addToCart(id, qty, btn) {
    if (!id || id === 'undefined' || id === 'null' || String(id).trim() === '') {
      toast('Error: no se encontró la variante del producto');
      return;
    }
    if (btn) { btn.disabled = true; btn.classList.add('loading'); }
    var body = new FormData();
    body.append('id', String(id).trim());
    body.append('quantity', parseInt(qty, 10) || 1);
    body.append('sections', 'cart-drawer');
    var addUrl = (K.routes && K.routes.cartAdd ? K.routes.cartAdd : '/cart/add') + '.js';
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.classList.remove('loading'); }
        if (res && res.status) {           // error de Shopify (stock, variante, etc.)
          toast(res.description || res.message || 'No se pudo agregar al carrito');
          return;
        }
        if (res && res.sections && res.sections['cart-drawer']) {
          updateCartHtml(res.sections['cart-drawer']);
          openCart();
          toast('Producto agregado');
        } else {
          return refreshCart().then(function () {
            openCart();
            toast('Producto agregado');
          });
        }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('loading'); }
        toast('No se pudo agregar al carrito');
      });
  }

  function changeLine(line, qty) {
    var drawer = $('cartDrawer');
    if (drawer) drawer.classList.add('loading');
    var changeUrl = (K.routes && K.routes.cartChange ? K.routes.cartChange : '/cart/change') + '.js';
    return fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (drawer) drawer.classList.remove('loading');
        if (res && res.status) {
          toast(res.description || res.message || 'No se pudo actualizar la cantidad');
        }
        if (res && res.sections && res.sections['cart-drawer']) {
          updateCartHtml(res.sections['cart-drawer']);
        } else {
          return refreshCart();
        }
      })
      .catch(function () {
        if (drawer) drawer.classList.remove('loading');
        return refreshCart();
      });
  }

  /* ---------- Interacciones ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-kura-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    var btn = form.querySelector('button[type="submit"]');
    addToCart(id && id.value, qty && qty.value, btn);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('#cartOpen')) {
      e.preventDefault();
      openCart();
      refreshCart();
      return;
    }
    if (t.closest('#cartClose') || t.closest('#cartBackdrop')) { e.preventDefault(); closeCart(); return; }

    var inc = t.closest('[data-kura-inc]'), dec = t.closest('[data-kura-dec]'), rem = t.closest('[data-kura-remove]');
    if (inc || dec || rem) {
      e.preventDefault();
      var line = +((inc || dec || rem).getAttribute(inc ? 'data-kura-inc' : dec ? 'data-kura-dec' : 'data-kura-remove'));
      var card = (inc || dec || rem).closest('.cart-line');
      var current = card ? parseInt((card.querySelector('.cart-qty span') || {}).textContent, 10) || 1 : 1;
      changeLine(line, rem ? 0 : (inc ? current + 1 : Math.max(0, current - 1)));
      return;
    }

    /* Miniaturas de la galería */
    var thumb = t.closest('[data-kura-thumb]');
    if (thumb) {
      e.preventDefault();
      var main = $('pdpImg');
      if (main) main.src = thumb.getAttribute('data-src');
      document.querySelectorAll('[data-kura-thumb]').forEach(function (b) { b.classList.remove('sel'); });
      thumb.classList.add('sel');
      return;
    }

    /* Planes 2x/3x: el precio mostrado lo calcula Liquid con el mismo % del descuento */
    var plan = t.closest('.plan[data-plan]');
    if (plan) {
      e.preventDefault();
      document.querySelectorAll('.plan').forEach(function (b) { b.classList.remove('sel'); });
      plan.classList.add('sel');
      var units = plan.getAttribute('data-units') || '1';
      ['kuraQty', 'kuraStickyQty'].forEach(function (id) { var el = $(id); if (el) el.value = units; });
      var priceEl = plan.querySelector('.plan-price');
      var sb = $('sbPrice');
      if (priceEl && sb) sb.textContent = priceEl.textContent;
      var st = $('pdpPrice');
      if (priceEl && st) st.textContent = priceEl.textContent;
      return;
    }

    /* Selector de cantidad (productos sin planes) */
    if (t.closest('#qtyInc') || t.closest('#qtyDec')) {
      e.preventDefault();
      var val = $('qtyVal');
      var n = Math.max(1, (parseInt(val.textContent, 10) || 1) + (t.closest('#qtyInc') ? 1 : -1));
      val.textContent = n;
      ['kuraQty', 'kuraStickyQty'].forEach(function (id) { var el = $(id); if (el) el.value = n; });
      return;
    }

    /* Quiz: muestra la recomendación que Liquid ya renderizó (nada de HTML armado en JS) */
    var q = t.closest('[data-kura-quiz]');
    if (q) {
      e.preventDefault();
      var box = $('quizResult');
      if (!box) return;
      var goal = q.getAttribute('data-goal');
      document.querySelectorAll('[data-kura-rec]').forEach(function (card) {
        card.hidden = card.getAttribute('data-kura-rec') !== goal;
      });
      box.hidden = false;
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    /* WhatsApp sin configurar: se avisa, no se finge que funciona */
    var inert = t.closest('[data-kura-inert="whatsapp"]');
    if (inert) {
      e.preventDefault();
      toast('WhatsApp sin configurar: define el número en los ajustes del tema');
    }
  });

  /* ---------- Cambio de variantes (productos con opciones) ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.kura-variant-select')) return;
    var jsonEl = $('kuraProductVariantsJson');
    if (!jsonEl) return;
    try {
      var variants = JSON.parse(jsonEl.textContent);
      var selects = Array.from(document.querySelectorAll('.kura-variant-select'));
      var selectedValues = selects.map(function (s) { return s.value; });
      var matched = variants.find(function (v) {
        return selectedValues.every(function (val, idx) {
          return v.options[idx] === val;
        });
      });
      if (matched) {
        var pdpForm = document.querySelector('.buy-box form[data-kura-form]');
        if (pdpForm) {
          var idInp = pdpForm.querySelector('input[name="id"]');
          if (idInp) idInp.value = matched.id;
        }
        var sbForm = document.querySelector('.sticky-buy form[data-kura-form]');
        if (sbForm) {
          var sbidInp = sbForm.querySelector('input[name="id"]');
          if (sbidInp) sbidInp.value = matched.id;
        }
        if (matched.price) {
          var formatted = '$' + (matched.price / 100).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
          var st = $('pdpPrice'); if (st) st.textContent = formatted;
          var sb = $('sbPrice'); if (sb) sb.textContent = formatted;
        }
        if (matched.featured_image && matched.featured_image.src) {
          var main = $('pdpImg'); if (main) main.src = matched.featured_image.src;
        }
      }
    } catch (err) { /* no-op */ }
  });

  /* ---------- Hero deslizante ---------- */
  function initHeroSlider() {
    var box = $('heroSlider');
    if (!box) return;
    var slides = box.querySelectorAll('.hero-slide');
    var dots = box.querySelectorAll('.hero-dot');
    if (slides.length < 2) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, timer = null;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('sel', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('sel', k === i); });
    }
    function start() { if (reduced) return; stop(); timer = setInterval(function () { go(i + 1); }, 5000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-hero-slide'), 10)); start(); });
    });
    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', start);
    box.addEventListener('focusin', stop);
    start();
  }

  /* ---------- Barra de compra fija ---------- */
  function initSticky() {
    var bar = $('stickyBuy');
    if (!bar) return;
    var box = $('comprar');
    if (!box || !('IntersectionObserver' in window)) { bar.hidden = false; return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.hidden = en.isIntersecting; });
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(box);
  }

  document.addEventListener('DOMContentLoaded', function () {
    closeCart();
    initHeroSlider();
    initSticky();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
})();
